<template>
    <div id="footer" class="html-footer clearfix">
        <div class="footer_con">
            <div class="flex">
                <div class="logo flex">
                    <img :src="app.webInfo.logo" alt="logo">
                </div>
                <div class="contact">
                    <!-- <p>{{ app.webInfo.companyName }}</p>
                    <p>公司地址: {{ app.webInfo.address }}</p> -->
                    <p>咨询电话: {{ app.webInfo.phone }}</p>
                    <p>企业微信：{{ app.webInfo.weCom }}</p>
                </div>
            </div>
            <div class="qr_code">
                <img src="@/assets/image/wx_qrcod.jpg" alt="二维码">
            </div>
        </div>
        <div class="footer_area">
            <p class="copyright"> Copyright(c) 徐州筑友教育咨询有限公司 版权所有 备案号：<a href="https://beian.miit.gov.cn/"
                    style="color: #999999;font-size: 14px;">苏ICP备2025155639号-2</a></p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: mapState(['app']),
  name: 'Footer',
  data () {
    return {

    }
  },
  async mounted () {
    this.GetWebInfo()
    try {
      // 获取网站信息
      await this.GetWebInfo()
    } catch (error) {}
  },
  methods: {
    ...mapActions('app', ['GetWebInfo'])
  }
}
</script>

<style lang="scss" scoped>
#footer {
    width: 100%;
    min-width: 1200px;
    height: 280px;
    background-color: #242424;
    text-align: center;
    box-sizing: border-box;

    .footer_con {
        padding-bottom: 28px;
        padding-top: 46px;
        margin: 0 auto;
        width: 1167px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #3F4159;
        box-sizing: border-box;

        .logo {
            align-items: flex-start;
            text-align: left;
            margin-left: 119px;

            img {
                width: 50px;
                height: 50px;
                margin-right: 10px;
            }

            h2 {
                font-size: 20px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 28px;
            }

            p {
                font-size: 14px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 28px;
            }
        }

        .contact {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
            text-align: left;
        }

        .qr_code {
            margin-right: 173px;

            img {
                width: 115px;
                height: 115px;
            }
        }
    }

    .footer_area {
        width: 100%;
        margin-top: 26px;
        text-align: center;

        p {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
        }
    }
}
</style>
